import { Lightning } from '@lightningjs/sdk';

export class ButtonRectangle extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      shader: {
        type: Lightning.shaders.RoundedRectangle,
      },
    };
  }

  _construct() {
    this._borderColor = 0;
    this._borderWidth = 0;
    this._borderRadius = 0;
  }

  get borderColor() {
    return this._borderColor;
  }

  set borderColor(value) {
    this._borderColor = value;
    this.patch({
      shader: {
        strokeColor: value,
      },
    });
  }

  get borderWidth() {
    return this._borderWidth;
  }

  set borderWidth(value) {
    this._borderWidth = value;
    this.patch({
      shader: {
        stroke: value,
      },
    });
  }

  get borderRadius() {
    return this._borderRadius;
  }

  set borderRadius(value) {
    this._borderRadius = value;
    this.patch({
      shader: {
        radius: value,
      },
    });
  }
}
